import { jsxs, jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { useInsideTooltip } from '@fabric-app/ui/components/Tooltip';
import { useQueryUserInfo } from '../../../user/queries/useQueryUserInfo.js';
import { Flex } from '@fabric-app/ui/components/Flex';
import { Button } from '@fabric-app/ui/components/Button';

const UserTooltip = ({ member, following, spotlightSelf, followUser, anonId, showFollowControls }) => {
  const { setOpen } = useInsideTooltip();
  const { data: user } = useQueryUserInfo();
  const onClick = (e) => {
    e.stopPropagation();
    setOpen(false);
    return member.id === user?.id || member.id === anonId ? spotlightSelf?.(e) : followUser?.(member.id, e);
  };
  const buttonLabel = useMemo(() => {
    if (member.id === user?.id || member.id === anonId) {
      return "Spotlight";
    }
    if (following === member.id) {
      return "Unfollow";
    }
    return "Follow";
  }, [
    anonId,
    following,
    member.id,
    user?.id
  ]);
  return /* @__PURE__ */ jsxs(Flex, {
    direction: "column",
    alignItems: "center",
    gap: "text",
    children: [
      member.name,
      " ",
      anonId === member.id && " (you) ",
      member.role === "owner" && `(${member.role})`,
      member.online && showFollowControls && followUser && spotlightSelf && /* @__PURE__ */ jsx(Button, {
        size: "xs",
        onPointerDown: onClick,
        children: buttonLabel
      })
    ]
  });
};

export { UserTooltip as default };
//# sourceMappingURL=UserTooltip.js.map
